module.exports = __webpack_public_path__ + "img/icon_cowmounting_colour.520ad27d.svg";